export default "__VITE_ASSET__3fb8acc0__"